// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_FetchDeviceTokenResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/devices_franquias/fetch_device_token
 *
 * Returns the device token fetched from the Evolution API (and persisted on
 * the row) plus a confirmation message.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface DevicesFranquias_FetchDeviceTokenResponseDados {
device_token: string
message: string
}

export type DevicesFranquias_FetchDeviceTokenResponse = ApiResponse<DevicesFranquias_FetchDeviceTokenResponseDados>;

registerResponseContract('DevicesFranquias_FetchDeviceTokenResponse', {
  device_token: { type: 'string',  required: true },
  message:      { type: 'string',  required: true },
})
